import {
    get,
    getJson,
    post,
    post1,
    postJson,
    put,
    delJson,
    delBodyJson,
    postExcel,
    postForm
} from './helpers'

const apiUrl = '/api'
const aiApiUrl = process.env.VUE_APP_AI_API_BASE_URL || 'http://127.0.0.1:8005/api/v2'


// Auth  APIs
export const auth = {
    login: postJson(`${apiUrl}/login/`),
    getRoleResources: getJson(`${apiUrl}/role_resources/`),
    getUserInfo: getJson(`${apiUrl}/user_info`),//鑾峰彇鐢ㄦ埛淇℃伅
    updateUserInfo: put(`${apiUrl}/user_info`),//淇敼鐢ㄦ埛淇℃伅
    userHeaderPic: post1(`${apiUrl}/user_header_pic`),
    delUserHeaderPic: delJson(`${apiUrl}/user_header_pic`),
    logout: postJson(`${apiUrl}/logout`),
    changeCompany: postJson(`${apiUrl}/change_company/`),
    getUserCompanies: getJson(`${apiUrl}/user_companies/`),//鑾峰彇鐢ㄦ埛鍏徃鍒楄〃
    role: getJson(`${apiUrl}/roles/`),
    getSalt: getJson(`${apiUrl}/get_salt`),
    userApiKey: postJson(`${apiUrl}/user_api_key`),
    resetPassword: postJson(`${apiUrl}/reset_password`),
    loginPhone: postJson(`${apiUrl}/login_phone`),//鏍℃楠岃瘉鐮佸苟鐧诲綍
    sendPhoneSms: postJson(`${apiUrl}/send_phone_sms`),//鑾峰彇楠岃瘉鐮?

}

// Project  APIs
export const projects = {
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getProjectTestActivityChart: getJson(`${apiUrl}/project_test_activity_chart`),//鍥捐〃
    getProjectActivityTestChanges: getJson(`${apiUrl}/project_activity_test_changes`),//娴嬭瘯鍙樻洿
    getProjectHistoryList: getJson(`${apiUrl}/project_history_list`),//鍘嗗彶
    getProjectStatusTestChangest: getJson(`${apiUrl}/project_status_test_changes`),//鐐瑰嚮鍥捐〃
    getTop3Milestones: getJson(`${apiUrl}/top3Milestones`),//鍓嶄笁涓猰ilstone
    getTop3RunPlans: getJson(`${apiUrl}/top3RunPlans`),//鍓嶄笁涓猵lan/run
    getOverviewTodoList: getJson(`${apiUrl}/todo/overview_todo_list`),//todo-list
    getFavoriteProjects: getJson(`${apiUrl}/favorite_projects/`),
    getActiveProjects: getJson(`${apiUrl}/active_projects/`),
    getDashboardProjects: getJson(`${apiUrl}/dashboard_projects/`),
    favoriteProject: postJson(`${apiUrl}/favorite_project`),
    unfavoriteProject: delJson(`${apiUrl}/favorite_project`),
    addProject: postJson(`${apiUrl}/project`),//娣诲姞椤圭洰
    addTestsuite: postJson(`${apiUrl}/suite`),
    getProjectNum: getJson(`${apiUrl}/project_num/`),
    getProjectTop: getJson(`${apiUrl}/project_top5`),

}

// Milestone  APIs
export const milestones = {
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getMilestonesOverview: getJson(`${apiUrl}/milestonesOverview`),
    getOpenMilestones: getJson(`${apiUrl}/openMilestones`),//閲岀▼纰戝垪琛?
    getCompleteMilestones: getJson(`${apiUrl}/completeMilestones`),//瀹屾垚閲岀▼纰戝垪琛?
    getUpcomingeMilestones: getJson(`${apiUrl}/upcomingMilestones`),//鍗冲皢鍒版潵閲岀▼纰戝垪琛?
    deleteMilestone: delJson(`${apiUrl}/milestone`),//鍒犻櫎鍗曚釜閲岀▼纰?
    deleteMilestones: postJson(`${apiUrl}/delete_milestones`),//鎵归噺鍒犻櫎閲岀▼纰?
    getSubmilestones: getJson(`${apiUrl}/submilestones`),//鑾峰彇瀛愰噷绋嬬鍒楄〃
    getMilestonesDetail: getJson(`${apiUrl}/milestoneDetail`),//鑾峰彇閲岀▼纰戣鎯?
    getMilestoneResult: getJson(`${apiUrl}/milestone_result_statistics`),//鑾峰彇閲岀▼纰戞祴璇曠粨鏋滅粺璁?
    getMilestoneStatusTestList: getJson(`${apiUrl}/milestone_status_test_list`),//鐐瑰嚮楗煎浘鑾峰彇鍒楄〃
    getMilestoneTestActivity: getJson(`${apiUrl}/milestone_test_activity`),//閲岀▼纰戠殑activity
    getMilestoneProgress: getJson(`${apiUrl}/milestone_progress`),//閲岀▼纰戠殑progress
    getMilestoneBugsChart: getJson(`${apiUrl}/milestone_bugs_chart`),//閲岀▼纰戠殑bug
    getMilestoneStatusTestChanges: getJson(`${apiUrl}/milestone_status_test_changes`),//閲岀▼纰戠殑activiity鐐瑰嚮鍥捐〃
    deletePlansRuns: postJson(`${apiUrl}/delete_plans_runs`),//鎵归噺鍒犻櫎璁″垝/杩愯
    getMilestoneProgressTests: getJson(`${apiUrl}/milestone_progress_tests`),//閲岀▼纰憄rogrees鐐瑰嚮鍥捐〃
    addMilestone: postJson(`${apiUrl}/milestone`),//娣诲姞閲岀▼纰?
    getParentMilestones: getJson(`${apiUrl}/parentMilestones`),//鑾峰彇鐖堕噷绋嬬
    updateMilestone: put(`${apiUrl}/milestone`),//淇敼閲岀▼纰?
    upLoadFile: post1(`${apiUrl}/new_attachment`),//涓婁紶鍥剧墖
    milestoneReopen: postJson(`${apiUrl}/milestone_reopen`),//鎭㈠鍏抽棴閲岀▼纰?
}

// Test Results APIs
export const testResults = {
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getRunsOverview: getJson(`${apiUrl}/test_runs_overview`),
    getOpenTestruns: getJson(`${apiUrl}/run_open`),
    getUpcomingTestruns: getJson(`${apiUrl}/run_upcoming`),
    getCompletionPendingTestruns: getJson(`${apiUrl}/run_completing`),
    getCompletedTestruns: getJson(`${apiUrl}/run_completed`),
    getAllSuite: getJson(`${apiUrl}/all_suites`),
    deleteTestrun: delJson(`${apiUrl}/run`),//鍒犻櫎run
    deleteTestPlan: delJson(`${apiUrl}/plan`),//鍒犻櫎plan
    deletePlansRuns: postJson(`${apiUrl}/delete_plans_runs`),//鎵归噺鍒犻櫎璁″垝/杩愯
    getCaseFields: getJson(`${apiUrl}/case_fields`),//鑾峰彇test鍙睍绀虹殑鍒楃殑瀛楁
    user: getJson(`${apiUrl}/users/`),
    getTestPlan: getJson(`${apiUrl}/plan`),//
    getRunTestResultStatistics: getJson(`${apiUrl}/test_result_statistics`),//鑾峰彇娴嬭瘯缁撴灉鍥捐〃鏁版嵁
    getRunDetailExportFields: getJson(`${apiUrl}/run_detail_export_fields`),
    exportRunDetailCsv: postJson(`${apiUrl}/export_run_detail_csv`),
    exportRunDetailExcel: postExcel(`${apiUrl}/export_run_detail_excel`),
    rerunPlan: postJson(`${apiUrl}/rerun_plan`),//鑾峰彇rerun plan椤甸潰鐨勬暟鎹?
    getPlanTestActivity: getJson(`${apiUrl}/plan_test_activity`),//Plan 鐨刟ctivity椤甸潰鎺ュ彛
    getPlanTestProgress: getJson(`${apiUrl}/plan_progress`),// Plan progress鎺ュ彛
    getPlanTestBugsChart: getJson(`${apiUrl}/plan_bugs_chart`),//Plan鐨勭己闄烽〉闈㈡帴鍙?
    getPlanStatusTestChanges: getJson(`${apiUrl}/plan_status_test_changes`),
    getPlanProgressTests: getJson(`${apiUrl}/plan_progress_tests`),
    getTestFirstSectionId: getJson(`${apiUrl}/test_first_section_id`),//褰搒ectionType涓?鎴?鏃讹紝鑾峰彇绗竴涓猻ection_id
    getTestTree: getJson(`${apiUrl}/test_tree`),//鑾峰彇test鏍戝拰section鏍?
    testSortFilter: postJson(`${apiUrl}/test_sort_filter`),//鎺掑簭鍜岃繃婊?
    testExpandSection: put(`${apiUrl}/test_expand_section`),//灞曞紑鎴栨姌鍙爏ection鑺傜偣
    assignCaseToUser: postJson(`${apiUrl}/add_assign`),//test娣诲姞assignee
    assignCasesToUser: postJson(`${apiUrl}/batch_add_assign`),//鎵归噺娣诲姞assignee
    addCaseTestResult: postJson(`${apiUrl}/add_test_result`),//娣诲姞娴嬭瘯缁撴灉
    getTestExpandSections: getJson(`${apiUrl}/test_expand_sections`),//鑾峰彇section鏍戝睍寮€鍜屾姌鍙犵殑鎺ュ彛
    getResultFields: getJson(`${apiUrl}/result_fields`),//result寮规銆佽幏鍙杛esult鐨勫瓧娈?
    bulkAddCaseTestResults: postJson(`${apiUrl}/batch_add_test_result`),
    getTemplateResultFields: getJson(`${apiUrl}/template_result_fields`),//result瀛楁鍜宼emplate鍏宠仈
    addTestreRun: postJson(`${apiUrl}/reRun`),
    getTestActivity: getJson(`${apiUrl}/test_activity`),
    getTestActivityChart: getJson(`${apiUrl}/test_activity_chart`),
    getStatusTestList: getJson(`${apiUrl}/status_test_list`),
    getRunProgressChart: getJson(`${apiUrl}/run_progress_chart`),//Run progress鎺ュ彛
    getRunProgressChartList: getJson(`${apiUrl}/run_progress_test_list`),//鐐瑰嚮chart涓妑emain tests鐨勮妭鐐癸紝鑾峰彇灞曠ずtest鍒楄〃
    getRunBugsChart: getJson(`${apiUrl}/run_bugs_chart`),
    getRunStatusTestChanges: getJson(`${apiUrl}/run_status_test_changes`),
    getCaseTree: getJson(`${apiUrl}/case_tree`),
    addTestPlan: postJson(`${apiUrl}/plan`),//鏂板plan
    getAllMilestoneList: getJson(`${apiUrl}/allMilestoneList`),//鑾峰彇閲岀▼纰戜笅鎷夐€夐」
    runSelectSectionTree: postJson(`${apiUrl}/run_select_section_tree`),//鑾峰彇section_tree鍜岀涓€涓猻ection鐨刢ase鍒楄〃
    getPlanConfig: getJson(`${apiUrl}/plan_config`),//鑾峰彇鍒嗙粍鍜岄厤缃?
    planConfigGroup: postJson(`${apiUrl}/plan_config_group`),//鏂板閰嶇疆鐨刧roup
    getPlanConfigGroups: getJson(`${apiUrl}/plan_config_groups`),
    planConfig: postJson(`${apiUrl}/plan_config`),//鏂板鍏蜂綋閰嶇疆锛?
    putPlanConfigGroup: put(`${apiUrl}/plan_config_group`),//淇敼group鎺ュ彛
    putplanConfig: put(`${apiUrl}/plan_config`),//淇敼閰嶇疆
    getProjctPlans: getJson(`${apiUrl}/project_plans`),
    runSelectCase: postJson(`${apiUrl}/run_select_case`),//鏍规嵁section_id鑾峰彇case鍒楄〃
    addTestrun: postJson(`${apiUrl}/run`),//娣诲姞杩愯
    SelectCasesNum: postJson(`${apiUrl}/select_cases_num`),//鏍规嵁鍏ㄩ€夌殑section_ids鍒楄〃鑾峰彇case鏁伴噺
    getCaseNum: getJson(`${apiUrl}/select_cases_num`),//鏍规嵁鍏ㄩ€夌殑section_ids鍒楄〃鑾峰彇case鏁伴噺
    editTestPlan: put(`${apiUrl}/plan`),//淇敼plan
    getEditRunSpecialTree: getJson(`${apiUrl}/get_edit_run_special_tree`),//鑾峰彇edit run鐨勯€夋嫨case鐨勫脊妗嗙殑section鏍戝拰绗竴涓猻ection瀵瑰簲鐨刢ase鏁扮粍
    editRun: put(`${apiUrl}/run`),//edit run椤甸潰鑾峰彇section鏍戝強绗竴涓猻ection瀵瑰簲鐨刢ase鍒楄〃
    getEditRunSectionCases: postJson(`${apiUrl}/edit_run_section_cases`),
    addRerunPlan: postJson(`${apiUrl}/add_rerun_plan`),//鏂板rerun鐨刾lan
    getTemplates: getJson(`${apiUrl}/templates`),
    getTemplateFields: getJson(`${apiUrl}/template_fields`),
    getTestResultDetail: getJson(`${apiUrl}/get_test_result_detail`),//鑾峰彇娴嬭瘯鐢ㄤ緥鐨勬祴璇曠粨鏋?
    reRunSectionCase: postJson(`${apiUrl}/rerun_select_section_cases`),//閲嶆柊閫夋嫨section鎴朿ase寮规鐨勬暟鎹?
    reRunSelectCases: postJson(`${apiUrl}/rerun_select_cases`),//鐐瑰嚮section, 鑾峰彇瀵瑰簲case鐨勬暟鎹?
    addReRun: postJson(`${apiUrl}/add_reRun`),
    getTestReRun: getJson(`${apiUrl}/reRun`),//鑾峰彇rerun鐨勫熀纭€淇℃伅
    getPlanTestStatusTestList: getJson(`${apiUrl}/plan_status_test_list`),//Plan detail椤甸潰鐐瑰嚮楗煎浘鏄剧ずtest鍒楄〃
    getPlan: getJson(`${apiUrl}/plan`),//鑾峰彇plan
    getCaseStatusChart: getJson(`${apiUrl}/case_status_chart`),//鑾峰彇test case chart
    getHistoryContext: getJson(`${apiUrl}/history_context`),//鑾峰彇test 鐘舵€佸垪琛?
    getCaseBugsChart: getJson(`${apiUrl}/case_bugs_chart`),//鑾峰彇test bug鍥捐〃
    updateTestCase: put(`${apiUrl}/case`),
    getRun: getJson(`${apiUrl}/run`),
    upLoadFile: post1(`${apiUrl}/new_attachment`),//涓婁紶鍥剧墖
    testSectionType: postJson(`${apiUrl}/test_section_type`),//淇濆瓨type
    getTestSectionTypes: getJson(`${apiUrl}/test_section_types`),//鑾峰彇type
    runEditFilterSectionTree: postJson(`${apiUrl}/run_edit_filter_section_tree`),
    deleteAttachment: delJson(`${apiUrl}/attachment`),//鍒犻櫎attachment
    updateTestField: put(`${apiUrl}/test_field`),// put test_field 淇敼test_field
    deleteAttachments: postJson(`${apiUrl}/delete_attachments`),//鎵归噺鍒犻櫎attachment
    updateTestResult: put(`${apiUrl}/test_result_field`),//淇敼缁撴灉
    updateAssign: put(`${apiUrl}/update_assign`),//淇敼鍒嗛厤
    addTestResultAndNext: postJson(`${apiUrl}/add_test_result_and_next`),//娣诲姞鍜屼笅涓€涓?
    sectionCaseIds: postJson(`${apiUrl}/section_case_ids`),//鑾峰彇section_case_ids

}

// Test Case  APIs
export const testCases = {
    copyCase: postJson(`${apiUrl}/copy_case`),//鎷疯礉涓€涓猚ase
    getDefaultSections: getJson(`${apiUrl}/default_sections`), // get default_sections锛?
    updateTestsuite: put(`${apiUrl}/suite`),// put suite锛?淇敼suite
    softDeleteBatchTestCase: delBodyJson(`${apiUrl}/soft_delete_cases`),//delete soft_delete_cases:鎵归噺杞垹闄ゅ涓猚ase
    hardDeleteBatchTestCase: delBodyJson(`${apiUrl}/hard_delete_cases`),//鎵归噺纭垹闄ゅ涓猚ase
    addSection: postJson(`${apiUrl}/section`),//鏂板涓€涓猻ection
    getSectionCaseCount: getJson(`${apiUrl}/suite_and_section_case_count`),//鑾峰彇case涓暟銆乻ection鐨勪釜鏁板拰suite淇℃伅
    getCaseOverviewBootstrap: getJson(`${apiUrl}/case_overview_bootstrap`),
    moveSection: postJson(`${apiUrl}/move_section`),// 绉诲姩涓€涓猻ection
    userConfigUpdate: put(`${apiUrl}/update_query_config`),//淇敼user鐩稿叧鏌ヨ閰嶇疆
    getSubSections: getJson(`${apiUrl}/sub_sections`),//鑾峰彇璇ection涓嬩竴灞傜殑瀛恠ections
    getCaseFields: getJson(`${apiUrl}/case_fields`),//鑾峰彇case瀛楁
    getFiltercases: postJson(`${apiUrl}/filter_section_cases_list`),//杩囨护鍚庣殑section鍜宑ase鏁扮粍
    copySection: postJson(`${apiUrl}/copy_section`),//鎷疯礉涓€涓猻ection
    user: getJson(`${apiUrl}/users/`),//鑾峰彇user鍒楄〃
    moveCase: postJson(`${apiUrl}/move_case`),//绉诲姩case
    getCaseTree: getJson(`${apiUrl}/case_tree`), //榛樿鐨?
    editSection: put(`${apiUrl}/section`),//缂栬緫section鐨刵ame
    updateCaseTitle: put(`${apiUrl}/case_title`),//淇敼case鐨則itle
    addTestCase: postJson(`${apiUrl}/case`),//娣诲姞鐢ㄤ緥
    deleteSection: delJson(`${apiUrl}/section`),//鍒犻櫎section
    softDeleteSingleTestCase: delBodyJson(`${apiUrl}/soft_delete_case`),//杞垹闄ase
    hardDeleteSingleTestCase: delJson(`${apiUrl}/hard_delete_case`),//纭垹闄ase
    sortFilter: postJson(`${apiUrl}/sort_filter`),//鎺掑簭銆佽繃婊?
    caseAssign: postJson(`${apiUrl}/case_assign`),//鍒嗛厤
    expandSection: put(`${apiUrl}/expand_section`),//section鑺傜偣灞曞紑
    getExpandSection: getJson(`${apiUrl}/expand_sections`),//鑾峰彇灞曞紑鐨勮妭鐐?
    getUpdatedDisplay: getJson(`${apiUrl}/cases_filter_updated_display`),//鎵€鏈夊凡杩囨护鐨?
    getTemplates: getJson(`${apiUrl}/templates`),
    getCaseExportFields: getJson(`${apiUrl}/case_export_fields`),
    exportCases: postJson(`${apiUrl}/export_cases`),
    caseSectionType: postJson(`${apiUrl}/case_section_type`),
    getTemplateFields: getJson(`${apiUrl}/template_fields`),
    getTestCaseDetail: getJson(`${apiUrl}/case_detail`),
    updateTestCases: put(`${apiUrl}/cases`),
    nextCaseDetail: postJson(`${apiUrl}/next_case_detail`),
    getCaseStatusChart: getJson(`${apiUrl}/case_status_chart`),
    getCaseStatuses: getJson(`${apiUrl}/case_statuses`),
    getCaseTests: getJson(`${apiUrl}/case_tests`),
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getTestCaseHistory: getJson(`${apiUrl}/case_history`),
    getCaseBugsChart: getJson(`${apiUrl}/case_bugs_chart`),
    getTestCaseManyEditDisplay: postJson(`${apiUrl}/cases_updated_display`),
    getCaseMindSection: getJson(`${apiUrl}/sections`),//鎬濈淮瀵煎浘鏍?
    caseCsvImportCases: post1(`${apiUrl}/csv_import_cases`),//瀵煎叆csv
    updateTestCase: put(`${apiUrl}/case`),
    excelExportCases: postExcel(`${apiUrl}/excel_export_cases`),
    exportCaseCsvMoudle: postJson(`${apiUrl}/export_case_csv_moudle`),
    exportCaseExcelMoudle: postExcel(`${apiUrl}/export_case_excel_moudle`),
    excelImportCases: post1(`${apiUrl}/excel_import_cases`),
    updateCaseField: put(`${apiUrl}/case_field`),//鍙屽嚮淇敼case
    updateCasesField: put(`${apiUrl}/cases_field`),//鎵归噺淇敼case
}

// Bug  APIs
export const bugs = {
    user: getJson(`${apiUrl}/users/`),
    getAllMilestoneList: getJson(`${apiUrl}/allMilestoneList`),//鑾峰彇閲岀▼纰戜笅鎷夐€夐」
    getAllBugFields: getJson(`${apiUrl}/all_bug_fields`),// 鑾峰彇bug鑷畾涔夊瓧娈?
    getProjectNames: getJson(`${apiUrl}/project_names/`),//鑾峰彇鎵€鏈夐」鐩?
    getBugRuns: getJson(`${apiUrl}/bug_runs`),
    getBugPlans: getJson(`${apiUrl}/bug_plans`),
    addCasebug: postJson(`${apiUrl}/bug`),// 娣诲姞case bug
    runSelectSectionTree: postJson(`${apiUrl}/run_select_section_tree`),//鑾峰彇section_tree鍜岀涓€涓猻ection鐨刢ase鍒楄〃
    runSelectCase: postJson(`${apiUrl}/run_select_case`),//鏍规嵁section_id鑾峰彇case鍒楄〃
    getBugDetail: getJson(`${apiUrl}/bug_detail`),//bug璇︽儏
    addBugComment: postJson(`${apiUrl}/bug_comment`),//bug娣诲姞璇勮
    bugCases: postJson(`${apiUrl}/bug_cases`),//娣诲姞bug case
    deleteBugCases: postJson(`${apiUrl}/delete_bug_cases`),//鍒犻櫎澶氫釜bug case
    deleteBugCase: postJson(`${apiUrl}/delete_bug_case`),//鍒犻櫎涓€涓猙ug case
    putBug: put(`${apiUrl}/bug`),//淇敼bug
    bugLane: postJson(`${apiUrl}/bug_lane`),//璁剧疆鏄剧ず鐨勯」鐩?
    bugLaneExpand: postJson(`${apiUrl}/bug_lane_expand`),//璁剧疆娉抽亾灞曞紑闂悎
    getBugLaneProcess: getJson(`${apiUrl}/bug_lane_process`),//鑾峰彇娉抽亾鍜宐ug鐨勬祦绋?
    bugLaneFilter: postJson(`${apiUrl}/bug_lane_filter`),//璁剧疆bug鐨勮繃婊ゆ潯浠?
    getBugLaneDetailss: getJson(`${apiUrl}/bug_lane_details`),//鏍规嵁鐢ㄦ埛鑾峰彇娉抽亾涓樉绀?
    getBugProcessResources: getJson(`${apiUrl}/bug_process_resources`),//bug鐘舵€併€佷笅鎷夐€夐」
    getBugHistories: getJson(`${apiUrl}/bug_histories`),//bug鍘嗗彶璁板綍
    getBugProcessAllResources: getJson(`${apiUrl}/bug_process_all_resources`),//
    upLoadFile: post1(`${apiUrl}/new_attachment`),//涓婁紶鍥剧墖
    getBugDetails: getJson(`${apiUrl}/bug_details`),//鑾峰彇鍗曚釜椤圭洰bug鐪嬫澘
    bugFilter: postJson(`${apiUrl}/bug_filter`),//鑾峰彇鍗曚釜椤圭洰杩囨护
    getSuite: getJson(`${apiUrl}/suite_info`),

}

// todo  APIs
export const todo = {
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getTodoChartAndRuns: getJson(`${apiUrl}/todo/chart_and_runs/`),//鑾峰彇todo鐨勫浘琛ㄥ拰runs
    todoSaveGroupbyFilter: postJson(`${apiUrl}/todo/save_groupby_filter`),//杩囨护
    getTodoMilestoneList: getJson(`${apiUrl}/todo/milestone_list/`),//鑾峰彇todo鐨勫浘琛ㄥ拰runs
    todoSetGroupby: postJson(`${apiUrl}/todo/set_groupby`),//鍗曠嫭璁剧疆鍒嗙粍
    getTodoGroupbyRuns: getJson(`${apiUrl}/todo/groupby_runs`),//鍗曠嫭淇敼鍒嗙粍锛屾洿鏂皉un鍒楄〃
    getTodoDashboard: getJson(`${apiUrl}/todo/get_dashboard/`),//鑾峰彇dashboard
    getTodoCaseList: getJson(`${apiUrl}/todo/case_list`),//鑾峰彇case_list
    todoSetCaseGroupby: postJson(`${apiUrl}/todo/set_case_groupby`),//鍗曠嫭璁剧疆case鍒嗙粍
    todoSaveCaseGroupbyFilter: postJson(`${apiUrl}/todo/save_case_groupby_filter`),//case杩囨护
    getTodoCaseStatuses: getJson(`${apiUrl}/field_case_statuses`),//鑾峰彇case_statuses
}

// Reports  APIs
export const setting = {
    getAllCaseFields: getJson(`${apiUrl}/all_case_fields`),
    deleteCaseField: delJson(`${apiUrl}/field`),
    getTemplates: getJson(`${apiUrl}/templates`),
    deleteTemplate: delJson(`${apiUrl}/template`),
    getStatuses: getJson(`${apiUrl}/all_status`),//鑾峰彇鐘舵€併€佽壊鍊?
    // deleteStatus: delJson(`${apiUrl}/status`),
    getAllTestFields: getJson(`${apiUrl}/all_test_fields`),
    addProject: postJson(`${apiUrl}/project`),
    getBugFields: getJson(`${apiUrl}/bug_fields`),
    deleteBugField: delJson(`${apiUrl}/bug_field`),
    addBugField: postJson(`${apiUrl}/bug_field`),
    getBugField: getJson(`${apiUrl}/bug_field`),
    updateBugField: put(`${apiUrl}/bug_field`),
    getBugProcesses: getJson(`${apiUrl}/bug_processes/`),
    updateBugProcessResources: put(`${apiUrl}/bug_process_all_resources`),
    getBugProcesseResources: getJson(`${apiUrl}/bug_process_all_resources`),
    getAllProjects: getJson(`${apiUrl}/all_projects`),
    getProjectInfo: getJson(`${apiUrl}/project_info/`),
    getApiTestEnvironments: getJson(`${apiUrl}/api_test_environments`),
    getApiTestEnvironment: getJson(`${apiUrl}/api_test_environments/:id`),
    addApiTestEnvironment: postJson(`${apiUrl}/api_test_environments`),
    updateApiTestEnvironment: put(`${apiUrl}/api_test_environments/:id`),
    toggleApiTestEnvironment: postJson(`${apiUrl}/api_test_environments/:id/toggle`),
    copyApiTestEnvironment: postJson(`${apiUrl}/api_test_environments/:id/copy`),
    deleteApiTestEnvironment: delJson(`${apiUrl}/api_test_environments/:id`),
    updateProjectAccesses: put(`${apiUrl}/project_accesses`),
    updateUser: put(`${apiUrl}/user`),
    addUser: postJson(`${apiUrl}/add_user`),//娣诲姞鐢ㄦ埛
    addUserProjectAccesses: postJson(`${apiUrl}/add_user_project_accesses`),//鐢ㄦ埛娣诲姞project_accesses
    exportUserExcelMoudle: postExcel(`${apiUrl}/export_user_excel_moudle`),//鎵归噺瀵煎叆user妯℃澘涓嬭浇
    excelImportUsers: postForm(`${apiUrl}/excel_import_users`),//鎵归噺瀵煎叆
    getProjectFieldsTemplates: getJson(`${apiUrl}/project_fields_templates`),
    projectFieldsTemplates: postJson(`${apiUrl}/project_fields_templates`),//鏂板project鍜屼慨鏀筽roject
    newProjectFieldsTemplates: postJson(`${apiUrl}/new_project_fields_templates`),


}

// requirement  APIs
export const requirement = {
    requirementSection: postJson(`${apiUrl}/requirement_section`),//娣诲姞闇€姹傜洰褰?
    putRequirementSection: put(`${apiUrl}/requirement_section`),//淇敼闇€姹傜洰褰?
    getRequirementSection: getJson(`${apiUrl}/requirement_section`),//鑾峰彇闇€姹傜洰褰?
    deleteRequirementSection: delJson(`${apiUrl}/requirement_section`),//鍒犻櫎闇€姹傜洰褰?
    moveRequirementSection: postJson(`${apiUrl}/move_requirement_section`),//绉诲姩闇€姹傜洰褰?
    requirement: postJson(`${apiUrl}/requirement`),//娣诲姞闇€姹?
    putRequirement: put(`${apiUrl}/requirement`),//淇敼闇€姹?
    getRequirementDetail: getJson(`${apiUrl}/requirement`),//鑾峰彇闇€姹傝鎯?
    hardDeleteRequirement: delJson(`${apiUrl}/hard_delete_requirement`),//纭垹闄ゅ崟鏉￠渶姹?
    hardDeleteRequirements: delBodyJson(`${apiUrl}/hard_delete_requirements`),//纭垹闄ゅ鏉￠渶姹?
    softDeleteRequirement: delJson(`${apiUrl}/soft_delete_requirement`),//杞垹闄ゅ崟鏉￠渶姹?
    softDeleteRequirements: delBodyJson(`${apiUrl}/soft_delete_requiremens`),//杞垹闄ゅ鏉￠渶姹?
    moveRequirement: postJson(`${apiUrl}/move_requirement`),//绉诲姩闇€姹?
    getRequirement: getJson(`${apiUrl}/requirement_tree`),//鑾峰彇闇€姹傛爲
    requirementSectionType: postJson(`${apiUrl}/requirement_section_type`),//璁剧疆闇€姹傞〉闈㈡爲鐨勬ā寮?
    getRequirementSectionTypes: getJson(`${apiUrl}/requirement_section_types`),//鑾峰彇闇€姹傞〉闈㈡爲鐨勬ā寮?
    getRequirementExpandSections: getJson(`${apiUrl}/requirement_expand_sections`),//鑾峰彇闇€姹俿ection鏍戝睍寮€鐨刜id鍒楄〃

}

// Reports  APIs
export const reports = {
    getStatuses: getJson(`${apiUrl}/statuses/`),//鑾峰彇鐘舵€併€佽壊鍊?
    getReports: getJson(`${apiUrl}/reports`),//鑾峰彇reports
    getReport: getJson(`${apiUrl}/report`),//鑾峰彇report
    reportMilestoneSummaryReport: postJson(`${apiUrl}/milestone_summary_report`),
    reportPlanSummaryReport: postJson(`${apiUrl}/plan_summary_report`),
    reportProjectSummaryReport: postJson(`${apiUrl}/project_summary_report`),
    reportRunSummaryReport: postJson(`${apiUrl}/run_summary_report`),
    getReportsMilestoneList: getJson(`${apiUrl}/report_milestone_list`),
    getReportsPlanList: getJson(`${apiUrl}/report_plan_list`),
    getReportsRunList: getJson(`${apiUrl}/report_run_list`),
    updateReportName: put(`${apiUrl}/report_name`),//淇敼鎶ュ憡鍚嶇О
    updateReportSummary: put(`${apiUrl}/report_summary`),//淇敼鎶ュ憡鎬荤粨
    deleteReport: delJson(`${apiUrl}/report`),//鍒犻櫎report
    deleteReports: postJson(`${apiUrl}/delete_reports`),//鍒犻櫎reports
}

// suite  APIs
export const suites = {
    delSuite: delJson(`${apiUrl}/suite`),//鍒犻櫎suite
    updateSuite: put(`${apiUrl}/suite`),//淇敼suite

}

// ai  APIs
export const ai = {
    aiGenerateCases: postJson(`${apiUrl}/ai_generate_cases`),//鏍规嵁闇€姹傜敓鎴愮敤渚?
    batchCases: postJson(`${apiUrl}/batch_cases`),//鎵归噺娣诲姞鐢ㄤ緥
    getAiCaseGenerate: getJson(`${apiUrl}/ai_case_generates`),//
    getAllAiModels: getJson(`${apiUrl}/all_ai_models`),//鑾峰彇ai閰嶇疆鍒楄〃
    getAiModel: getJson(`${apiUrl}/ai_model`),//鑾峰彇ai閰嶇疆
    addAiModel: postJson(`${apiUrl}/ai_model`),//鏂板ai閰嶇疆
    updateAiModel: put(`${apiUrl}/ai_model_field`),//淇敼ai閰嶇疆
    deleteAiModel: delJson(`${apiUrl}/ai_model`),//鍒犻櫎ai閰嶇疆
    testAiModel: postJson(`${apiUrl}/ai_model/test`),//调试模型连通性
}

// work_order  APIs
export const order = {
    closeWorkOrder: put(`${apiUrl}/close_work_order`),//鍏抽棴
    deleteWorkOrder: delJson(`${apiUrl}/work_order`),//鍒犻櫎
    getWorkOrder: getJson(`${apiUrl}/work_order`),//鑾峰彇
    addWorkOrder: postJson(`${apiUrl}/work_order`),//鏂板
    updateWorkOrder: put(`${apiUrl}/work_order`),//淇敼
    getWorkOrders: getJson(`${apiUrl}/work_orders`),//鑾峰彇
    getWorkOrdersCounts: getJson(`${apiUrl}/work_order_counts`),//鑾峰彇

}

export default {
    auth,
    projects,
    milestones,
    testCases,
    testResults,
    bugs,
    setting,
    todo,
    requirement,
    reports,
    suites,
    ai,
    order
}
